import { apiClient } from '../client/apiClient';

export const streamService = {
	/**
	 * Get stream data
	 */
	getStream: (count: number, interval: number) =>
		apiClient.get<string[]>('/stream', { params: { count, interval } }),
};
